export default __webpack_public_path__ + "static/media/blue.b54d58f8.png";